module Omni.Booker {
    
    export class BookingDataResult {
        City: string;
        ItemIdGuid: string;
        ResultLabel: string;
        State: string;
        SubCategory: any;
        category: string;
        label: string;
        selected: boolean;
        IsComingSoonProperty: boolean;
        ComingSoonText: string;
        HotelLink: string;
        RedeemFreeNights: boolean;
        HotelCode: string;
        Region_City: string;
        IsVillas: boolean;
        IsGha: boolean;

        constructor() {
            this.City = "";
            this.ItemIdGuid = "";
            this.ResultLabel = "";
            this.State = "";
            this.SubCategory = "";
            this.category = "";
            this.label = "";
            this.selected = false;
            this.IsComingSoonProperty = false;
            this.ComingSoonText = "";
            this.HotelLink = "";
            this.RedeemFreeNights = true;
            this.HotelCode = "";
            this.Region_City = "";
            this.IsVillas = false;
            this.IsGha = false;
        }
    }

    export class ExplorePropertyNavigation {
        public Text: string;
        public Target;
        public NavigateUrl: string;
        public SubItems: ExplorePropertyNavigation[];
    }

    export class ExplorePropertyResult {
        public ComingSoonText: string;
        public HotelCode: string;
        public HotelImage: {
            ImageUrl: string;
            ThumbnailImageUrl: string;
            MediumImageUrl: string,
            AltText: string;
        };
        public HotelName: string;
        public Id: string;
        public IsComingSoonProperty: boolean;
        public PropertyNavigation: {
            TopLevel: ExplorePropertyNavigation[],
            ReservationUrl: string,
            PropertyUrl: string;
        };
        public PropertyAddress: string;
        public PropertyCity: string;
        public PropertyCountry: string;
        public PropertyState: string;
        public PropertyZipcode: string;
        public PropertyTelephone: string;
        public PropertyLink: string;

    }

   

    export class BookerState {
        IsExpanded: boolean;
        IsEnabled: boolean;
        IsBrandPage: boolean;
        IsPropertyPage: boolean;
        IsResortPage: boolean;

        constructor(copy?: BookerState) {
            this.IsExpanded = copy ? copy.IsExpanded : false;
            this.IsEnabled = copy ? copy.IsEnabled : false;
            this.IsBrandPage = copy ? copy.IsBrandPage : false;
            this.IsPropertyPage = copy ? copy.IsPropertyPage : false;
            this.IsResortPage = copy ? copy.IsResortPage : false;
        }
    }


    
    export interface IBookingService {
        GetPropertyDetail(): PropertyDetail;
        GetTravelDates(): TravelDates;
        PutTravelDates(travelDates: TravelDates);
        GetRoomDetails(): RoomDetail;
        GetRateCodes(): RateCodes;
        PutRateCodes(rateCodes: RateCodes);
        GetGlobalDetail(): GlobalBookerDetails;
        OpenBooker();
        CloseBooker();
        ToggleBooker();
        TabBooker(event: KeyboardEvent);
        GetBookerState(): BookerState;
        GetCurrentDate() : Date;
        CheckBookerFocus() : boolean;
    }

    class BookingService implements IBookingService {
        private bookingCache: any;
        private bookerState: BookerState;

        static $inject = [
            "$rootScope",
            "$log",
            "CacheFactory",
            "moment",
            "bookerConfig",
            "dateConfig",
            "$timeout"
        ];
        constructor(
            private readonly $rootScope: ng.IRootScopeService,
            private readonly $log: ng.ILogService,
            private readonly cacheFactory: any,
            private readonly moment: any,
            private readonly bookerConfig: Constants.IBookerConfiguration,
            private readonly dateConfig: Constants.IDateConfiguration,
            private readonly $timeout: ng.ITimeoutService
        ) {
            this.initBookerDateConfig();
            this.initBookerState();
            this.initPageState();
            this.initBookerCache();
        }
        GetCurrentDate(): Date {
            return this.bookerConfig.CurrentDate;
        }
        GetPropertyDetail(): PropertyDetail {
            var propertyDetail = new PropertyDetail();
            propertyDetail.HotelId = "";
            return propertyDetail;
        }

        GetTravelDates(): TravelDates {
            var travelDates = new TravelDates();
            travelDates.ArrivalDate = this.moment.utc(this.bookerConfig.CurrentDate).hour(0).minute(0).second(0).millisecond(0);
            travelDates.DepartureDate = this.moment.utc(this.bookerConfig.CurrentDate).add(1, "days").hour(0).minute(0).second(0).millisecond(0);
            var cachedDates = this.bookingCache.get("travelDates");
            if (cachedDates) {
                this.$log.debug("Using cached travel dates", cachedDates);
                travelDates = cachedDates;
            }

            return travelDates;
        }

        PutTravelDates(travelDates: TravelDates) {
            this.bookingCache.put("travelDates", travelDates);
        }
        
        GetRoomDetails(): RoomDetail {
           
            var defaultRoomDetail = new RoomDetail();
            defaultRoomDetail.RoomCount = 1;
            defaultRoomDetail.BedRoomCount = new BedroomOption();
            defaultRoomDetail.BedRoomCount.Count = 0;
            defaultRoomDetail.VillasView = new ViewOption();
            defaultRoomDetail.VillasView.Value = '';

            var defaultRoom = new Room();
            defaultRoom.AdultCount = 2;
            defaultRoom.ChildCount = 0;
            defaultRoomDetail.Rooms.push(defaultRoom);
           
            return defaultRoomDetail;
        }

        GetRateCodes(): RateCodes {
            var rateCode = new RateCodes();
            rateCode.RateCode = "rpc_NONE";

            var cachedRates = this.bookingCache.get("rateCodes");
            if (cachedRates) {
                this.$log.debug("Using cached rates", cachedRates);
                rateCode = cachedRates;
            }

            return rateCode;
        }

        PutRateCodes(rateCodes: RateCodes) {
            this.bookingCache.put("rateCodes", rateCodes);
        }

        GetGlobalDetail(): GlobalBookerDetails {
            var globalDetails = new GlobalBookerDetails();
            globalDetails.Brand = "-1";
            globalDetails.City = "-1";
            globalDetails.Hotel = "-1";
            globalDetails.Country = "-1";

            var cachedDetails = this.bookingCache.get("globalBookerDetails");
            if (cachedDetails) {
                this.$log.debug("Using cached global details", cachedDetails);
            }

            return globalDetails;
        }

        PutGlobalDetail(globalDetail: GlobalBookerDetails) {
            this.bookingCache.put("globalBookerDetails", globalDetail);
        }

        OpenBooker() {
            if (this.bookerConfig.ShowBookingWidget) {
              this.bookerState.IsExpanded = true;
              this.onUpdatedBookerState();

                 this.$timeout(function () { 
                             var closeButton = angular.element("#closeButton");
                                closeButton.focus();
                        }, 0); 
                angular.element("#omni-booker #bookNowButton").attr("aria-expanded", "true");
                
                angular.element("#findAndBookLineItem").attr("aria-expanded", "true");
                angular.element("#bookNowLineItem").attr("aria-expanded", "true");
            }
        }

        CloseBooker() {
            var bookerHasFocus = this.CheckBookerFocus();
            
            if (this.bookerConfig.ShowBookingWidget && bookerHasFocus) {
                if (!this.bookerConfig.IsBookerAlwaysOpen) {
                    // configuration maintains booker can't be closed

                    if (this.bookerState.IsExpanded){
                        this.bookerState.IsExpanded = false;
                        this.$timeout(function () { 
                                var bookNowButton = angular.element("#omni-booker #bookNowButton");
                                bookNowButton.focus();

                            }, 0); 
                        angular.element("#omni-booker #bookNowButton").attr("aria-expanded", "false");
                        
                        angular.element("#findAndBookLineItem").attr("aria-expanded", "false");
                        angular.element("#bookNowLineItem").attr("aria-expanded", "false");
                    }

                    this.onUpdatedBookerState();
                }
            }
        }

        ToggleBooker() {
            if (this.bookerConfig.ShowBookingWidget) {
                if (!this.bookerConfig.IsBookerAlwaysOpen) {
                    // configuration maintains booker can't be closed
                    this.bookerState.IsExpanded = !this.bookerState.IsExpanded;

                    if (this.bookerState.IsExpanded){
                        this.$timeout(function () { 
                             var closeButton = angular.element("#closeButton");
                                closeButton.focus();
                        }, 0); 
                        angular.element("#bookNowButton").attr("aria-expanded", "true");
                    }
                    else{
                        angular.element("#bookNowButton").attr("aria-expanded", "false");
                    }

                    this.onUpdatedBookerState();
                }
            }   
        }

        TabBooker(event: KeyboardEvent) {
            let parentModal: any = angular.element('.om-booking-container');
            let focusableElementsInModal: any = parentModal.find(".bookerTabElement");
            let numberOfElements: any = focusableElementsInModal.length;
            let firstTabElement: any = focusableElementsInModal[0];
            let lastTabElement: any = focusableElementsInModal[numberOfElements - 1];
            
            if (event.keyCode === 9) {
                if (document.activeElement === lastTabElement) {
                    event.preventDefault();
                    firstTabElement.focus();
                }
            }
        }

        CheckBookerFocus(){
            // if the item that has focus does not have the id of the input field, AND does not have a tabbookeritem class, then we can say that the booker does not have focus.

            var currentFocusedItem = angular.element(document.activeElement);

            var bookerHasFocus = false;

            if (currentFocusedItem.hasClass("bookerTabElement") || 
                currentFocusedItem.attr("id") === "where-going" ||
                currentFocusedItem.is('body')){
                bookerHasFocus = true;
            }
            else{
                bookerHasFocus = false;
            }
            return bookerHasFocus;
        }

        GetBookerState() {
            // Make a copy, do not allow access to modify the internal state
            return new BookerState(this.bookerState);
        }

        private initPageState() {
            // TODO: Move this outside of booker, it can be applied to any page (will require changes in input field renderings).
            this.$rootScope["isbrand"] = this.bookerConfig.IsBrandPage();
            this.$rootScope["ishotel"] = this.bookerConfig.IsHotelPage();
            this.$rootScope["isresort"] = this.bookerConfig.IsResortPage();
        }

        private initBookerState() {
            // Setup booker state from configurations from sitecore / backend
            this.bookerState = new BookerState();
            this.bookerState.IsExpanded = this.bookerConfig.ShowBookingWidget && (this.bookerConfig.IsBookerExpanded || this.bookerConfig.IsBookerAlwaysOpen);
            this.bookerState.IsEnabled = this.bookerConfig.ShowBookingWidget;
            this.bookerState.IsBrandPage = this.bookerConfig.IsBrandPage();
            this.bookerState.IsPropertyPage = this.bookerConfig.IsHotelPage() || this.bookerConfig.IsResortPage();
            this.bookerState.IsResortPage = this.bookerConfig.IsResortPage();

            this.onUpdatedBookerState();
        }

        private initBookerDateConfig() {
            if (this.dateConfig.MonthsLong.length > 0 &&
                this.dateConfig.MonthsShort.length > 0 &&
                this.dateConfig.WeekdaysLong.length > 0 &&
                this.dateConfig.WeekdaysShort.length > 0) {
                this.moment.defineLocale("en-foo", {
                    parentLocale: "en"
                });

                this.moment.updateLocale("en-foo", {
                    months: this.dateConfig.MonthsLong,
                    monthsShort: this.dateConfig.MonthsShort,
                    weekdays: this.dateConfig.WeekdaysLong,
                    weekdaysShort: this.dateConfig.WeekdaysShort
                });
            }
        }

        private initBookerCache() {
            this.bookingCache = this.cacheFactory.get("bookingCache");

            // Create cache if it doesn't exist
            if (!this.bookingCache) {
                this.bookingCache = this.cacheFactory("bookingCache", {
                    storageMode: "sessionStorage"
                });
            }
        }
        
        private onUpdatedBookerState() {
            this.$rootScope["IsBookerEnabled"] = this.bookerState.IsEnabled;
            this.$rootScope["IsBookerExpanded"] = this.bookerState.IsExpanded;
            this.$rootScope.$broadcast("bookerStateUpdate");
        }
    }

    NgModule.service("omni.bookingservice", BookingService);
}
